import React, { useState } from "react";

import { Input } from "../../styles/ButtonStyles";
import styled, { css } from "styled-components/macro";
import "../customIcons/customIcons.css";

const Label = styled.label`
  display: flex;
  justify-content: center;
  border: 1px solid LightGray;
  width: 5rem;
  height: 5rem;
  text-align: center;
  padding: 1.5rem 0.75rem 0;
  flex: 0 0 auto;
  border-radius: 1rem;
  &:hover {
    background: #f9f9f9;
  }
  ${(props) =>
    props.active &&
    css`
      border: 2px solid #ed1968;
    `}
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  justify-content: center;
  width: 6rem;
  padding: 1rem;
`;

const ExtrasHeader = ({
  field,
  form: { values, setFieldValue, handleChange, handleBlur },
  id,
  icon,
  label,
}) => {
  const [active, setActive] = useState(false);
  const handleInputPress = () => {
    !field.name
      ? setFieldValue(field.name, "YES")
      : setFieldValue(field.name, !field.value);
    setActive(!active);
  };

  return (
    <Div>
      <p style={{ fontSize: 13, textAlign: "center" }}>{label}</p>
      <Label htmlFor={id} active={active}>
        {<i className={icon} />}
        <Input
          id={id}
          name={field.name}
          value={field.value}
          onChange={handleChange}
          onBlur={handleBlur}
          type="button"
          onClick={handleInputPress}
        />
      </Label>
    </Div>
  );
};

export default ExtrasHeader;
